import { formatPhoneNumberIntl } from "react-phone-number-input";

export const formatPhone = (phone: string): string => {
	if (!phone) return "";

	// Remove spaces
	const cleaned = phone.replaceAll(" ", "");

	// If already in format 000-0000000 (3 digits - rest digits)
	const alreadyFormatted = /^\d{3}-\d+$/.test(cleaned);
	if (alreadyFormatted) return cleaned;

	const formatted = (
		formatPhoneNumberIntl(phone).replace(" ", "-").split("-")[0].replace("+", "").padStart(3, "0") +
		"-" +
		formatPhoneNumberIntl(phone).replace(" ", "-").split("-")[1]
	).replaceAll(" ", "");
	return formatted;
};

export const reverseFormatPhone = (formattedPhone: string): string => {
	if (!formattedPhone) return "";

	const cleaned = formattedPhone.replaceAll(" ", "");
	const [countryCode, number] = cleaned.split("-");

	if (!countryCode || !number) return formattedPhone;

	const normalizedCountryCode = countryCode.replace(/^0+/, "");

	return `+${normalizedCountryCode}${number}`;
};